"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));

var _TableSortLabel = _interopRequireDefault(require("@material-ui/core/TableSortLabel"));

var _reactVirtualized = require("react-virtualized");

var _excluded = ["classes", "columns"],
    _excluded2 = ["cellContentRenderer", "className", "dataKey"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    table: {
      fontFamily: theme.typography.fontFamily
    },
    flexContainer: {
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box'
    },
    tableRow: {
      cursor: 'pointer'
    },
    tableRowHover: {
      '&:hover': {
        backgroundColor: theme.palette.grey[200]
      }
    },
    tableCell: {
      flex: 1
    },
    noClick: {
      cursor: 'initial'
    }
  };
};

var MuiVirtualizedTable = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MuiVirtualizedTable, _React$PureComponent);

  var _super = _createSuper(MuiVirtualizedTable);

  function MuiVirtualizedTable() {
    var _this;

    _classCallCheck(this, MuiVirtualizedTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getRowClassName", function (_ref) {
      var index = _ref.index;
      var _this$props = _this.props,
          classes = _this$props.classes,
          rowClassName = _this$props.rowClassName,
          onRowClick = _this$props.onRowClick;
      return (0, _classnames["default"])(classes.tableRow, classes.flexContainer, rowClassName, _defineProperty({}, classes.tableRowHover, index !== -1 && onRowClick != null));
    });

    _defineProperty(_assertThisInitialized(_this), "cellRenderer", function (_ref2) {
      var cellData = _ref2.cellData,
          _ref2$columnIndex = _ref2.columnIndex,
          columnIndex = _ref2$columnIndex === void 0 ? null : _ref2$columnIndex;
      var _this$props2 = _this.props,
          columns = _this$props2.columns,
          classes = _this$props2.classes,
          rowHeight = _this$props2.rowHeight,
          onRowClick = _this$props2.onRowClick;
      return /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
        component: "div",
        className: (0, _classnames["default"])(classes.tableCell, classes.flexContainer, _defineProperty({}, classes.noClick, onRowClick == null)),
        variant: "body",
        style: {
          height: rowHeight
        },
        align: columnIndex != null && columns[columnIndex].numeric || false ? 'right' : 'left'
      }, cellData);
    });

    _defineProperty(_assertThisInitialized(_this), "headerRenderer", function (_ref3) {
      var _direction;

      var label = _ref3.label,
          columnIndex = _ref3.columnIndex,
          dataKey = _ref3.dataKey,
          sortBy = _ref3.sortBy,
          sortDirection = _ref3.sortDirection;
      var _this$props3 = _this.props,
          headerHeight = _this$props3.headerHeight,
          columns = _this$props3.columns,
          classes = _this$props3.classes,
          sort = _this$props3.sort;
      var direction = (_direction = {}, _defineProperty(_direction, _reactVirtualized.SortDirection.ASC, 'asc'), _defineProperty(_direction, _reactVirtualized.SortDirection.DESC, 'desc'), _direction);
      var inner = !columns[columnIndex].disableSort && sort != null ? /*#__PURE__*/_react["default"].createElement(_TableSortLabel["default"], {
        active: dataKey === sortBy,
        direction: direction[sortDirection]
      }, label) : label;
      return /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
        component: "div",
        className: (0, _classnames["default"])(classes.tableCell, classes.flexContainer, classes.noClick),
        variant: "head",
        style: {
          height: headerHeight
        },
        align: columns[columnIndex].numeric || false ? 'right' : 'left'
      }, inner);
    });

    return _this;
  }

  _createClass(MuiVirtualizedTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          classes = _this$props4.classes,
          columns = _this$props4.columns,
          tableProps = _objectWithoutProperties(_this$props4, _excluded);

      return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, null, function (_ref4) {
        var height = _ref4.height,
            width = _ref4.width;
        return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.Table, _extends({
          className: classes.table,
          height: height,
          width: width
        }, tableProps, {
          rowClassName: _this2.getRowClassName
        }), columns.map(function (_ref5, index) {
          var _ref5$cellContentRend = _ref5.cellContentRenderer,
              cellContentRenderer = _ref5$cellContentRend === void 0 ? null : _ref5$cellContentRend,
              className = _ref5.className,
              dataKey = _ref5.dataKey,
              other = _objectWithoutProperties(_ref5, _excluded2);

          var renderer;

          if (cellContentRenderer != null) {
            renderer = function renderer(cellRendererProps) {
              return _this2.cellRenderer({
                cellData: cellContentRenderer(cellRendererProps),
                columnIndex: index
              });
            };
          } else {
            renderer = _this2.cellRenderer;
          }

          return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.Column, _extends({
            key: dataKey,
            headerRenderer: function headerRenderer(headerProps) {
              return _this2.headerRenderer(_objectSpread(_objectSpread({}, headerProps), {}, {
                columnIndex: index
              }));
            },
            className: (0, _classnames["default"])(classes.flexContainer, className),
            cellRenderer: renderer,
            dataKey: dataKey
          }, other));
        }));
      });
    }
  }]);

  return MuiVirtualizedTable;
}(_react["default"].PureComponent);

MuiVirtualizedTable.propTypes = {
  classes: _propTypes["default"].object.isRequired,
  columns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    cellContentRenderer: _propTypes["default"].func,
    dataKey: _propTypes["default"].string.isRequired,
    width: _propTypes["default"].number.isRequired
  })).isRequired,
  headerHeight: _propTypes["default"].number,
  onRowClick: _propTypes["default"].func,
  rowClassName: _propTypes["default"].string,
  rowHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].func]),
  sort: _propTypes["default"].func
};
MuiVirtualizedTable.defaultProps = {
  headerHeight: 56,
  rowHeight: 56
};

var _default = (0, _styles.withStyles)(styles)(MuiVirtualizedTable);

exports["default"] = _default;